<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; flex-direction: column; min-height: 80vh">
    <div class="label-wrapper">
      <img class="label-img" src="assets/fotos/cria-head.svg" />
    </div>

    <div class="container">
      <div class="information-container">
        <div class="info_containter">
          <a href="/cria">
            <img
              style="width: 150px; margin-top: -20px"
              src="assets/fotos/mn_principal.svg"
            />
          </a>
        </div>
      </div>

      <div class="leavings-container">
        <div class="row">
          <div class="col">
            <a href="/cria/didatica">
              <img
                class="label-img btn-menu"
                src="assets/fotos/mn-didatica.svg"
              />
            </a>
          </div>
          <div class="col">
            <a href="/cria/informacoes">
              <img class="label-img btn-menu" src="assets/fotos/mn-info.svg" />
            </a>
          </div>
          <div class="col">
            <a href="/cria/resultados">
              <img
                class="label-img btn-menu"
                src="assets/fotos/mn-resultados.svg"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="leavings-container">
        <img
          class="hide-on-med-and-down"
          style="width: 100%"
          src="assets/fotos/cria-informacoes.svg"
        />
        <img
          class="show-on-medium hide-on-med-and-up"
          style="width: 100%"
          src="assets/fotos/cria-informacoes_sm.svg"
        />
      </div>
    </div>
  </div>
</main>

<footer-component></footer-component>
